import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import EmailAttachments from './EmailAttachments/EmailAttachments'
import MetadataField from './MetadataField/MetadataField'
import * as Styles from './styles'

const EmailMetadata = ({ name, toName, to, created, subject, attachments }) => {
  const { t, i18n } = useTranslation()

  return (
    <Styles.Container>
      <Text type="bodyMBold">{name}</Text>
      {to && (
        <MetadataField label={t('Para')}>
          {toName && `${toName} `}
          <Styles.RecipientEmail>{`<${to}>`}</Styles.RecipientEmail>
        </MetadataField>
      )}
      {created && (
        <MetadataField label={t('Fecha')}>
          {new Intl.DateTimeFormat(i18n.language, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }).format(new Date(created))}
        </MetadataField>
      )}
      {subject && <MetadataField label={t('Asunto')}>{subject}</MetadataField>}
      {attachments?.length > 0 && <EmailAttachments attachments={attachments} />}
    </Styles.Container>
  )
}

export default EmailMetadata
